import * as types from './mutation-types'

export const loginAction = ({ commit }, { userInfo, isLogin, tokenTimeout, tenantId, classification }) => {
  commit(types.SET_USERINFO, userInfo)
  commit(types.SET_LOGIN, isLogin)
  commit(types.SET_TOKENTIMEOUT, tokenTimeout)
  commit(types.SET_TENANTID, tenantId)
  commit((types.SET_CLASSIFICATION), classification)
}

export const chatAction = ({ commit }, { chatNum }) => {
  commit(types.SET_CHATNUM, chatNum)
}
